import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type Variant = 'success' | 'error' | 'info';
interface Toast {
  id: number;
  message: string;
  variant: Variant;
}

const Ctx = createContext<(message: string, variant?: Variant) => void>(() => undefined);

/** Short confirmations at the bottom of the screen: "Tony was saved." */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<Toast | null>(null);
  const show = useCallback((message: string, variant: Variant = 'success') => setToast({ id: Date.now(), message, variant }), []);
  return (
    <Ctx.Provider value={show}>
      {children}
      <Snackbar
        key={toast?.id}
        open={!!toast}
        autoHideDuration={toast?.variant === 'error' ? 8000 : 4000}
        onClose={(_e, reason) => reason !== 'clickaway' && setToast(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={toast?.variant ?? 'success'} onClose={() => setToast(null)} variant="standard" sx={{ minWidth: 300 }}>
          {toast?.message}
        </Alert>
      </Snackbar>
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
